import { InitialETADuration, GateReleaseThreshold } from "api/consts";

export const initialETAOptions = {
  [InitialETADuration.MISSED_FIRST_ETA]: "PAST",
  [InitialETADuration.HOURS_0_47_OUT]: "WITHIN_48_HOURS",
  [InitialETADuration.HOURS_48_95_OUT]: "WITHIN_96_HOURS",
  [InitialETADuration.HOURS_96_OUT]: "BEYOND_96_HOURS",
};

export const initialETAOptionsShippers = {
  [InitialETADuration.WITHIN_PAST_72_HOURS]: "WITHIN_PAST_72_HOURS",
  [InitialETADuration.BEYOND_PAST_72_HOURS]: "BEYOND_PAST_72_HOURS",
  [InitialETADuration.HOURS_0_47_OUT]: "WITHIN_48_HOURS",
  [InitialETADuration.HOURS_48_95_OUT]: "WITHIN_96_HOURS",
  [InitialETADuration.HOURS_96_OUT]: "BEYOND_96_HOURS",
};

export const gateReleaseThresholdOptions = {
  [GateReleaseThreshold.DAYS_AGO_150]: "daysAgo150",
  [GateReleaseThreshold.DAYS_AGO_100_149]: "daysAgo100_149",
  [GateReleaseThreshold.DAYS_AGO_50_99]: "daysAgo50_99",
  [GateReleaseThreshold.DAYS_AGO_0_49]: "daysAgo0_49",
};
